import React, { useCallback, useRef, useState } from "react";
import _ from "lodash";
import { Button, Col, Form, Row } from "react-bootstrap";

const DoubleListbox = ({
  tituloEsquerda,
  listaEsquerda,
  tituloDireita,
  listaDireita,
  listaEsquerdaMultipla = true,
  textoBotaoAdicionar,
  textoBotaoRemover,
  itensVisiveis,
  disabled,
  onAdd = (itemsAdded = []) => {
    console.log(itemsAdded);
  },
  onRemove = (itemsRemoved = []) => {
    console.log(itemsRemoved);
  },
}) => {
  const listaEsquerdaRef = useRef(null);
  const listaDireitaRef = useRef(null);
  const [esquerdaTemSelecao, setEsquerdaTemSelecao] = useState(false);
  const [direitaTemSelecao, setDireitaTemSelecao] = useState(false);

  const onAddHandler = useCallback(() => {
    if (typeof onAdd === "function") {
      onAdd(
        _.map(listaEsquerdaRef.current.selectedOptions, (item) => ({ chave: +item.value, descricao: item.innerText })),
      );
    }
  }, [listaEsquerdaRef, onAdd]);

  const onRemoveHandler = useCallback(() => {
    if (typeof onRemove === "function") {
      onRemove(
        _.map(listaDireitaRef.current.selectedOptions, (item) => ({ chave: +item.value, descricao: item.innerText })),
      );
    }
  }, [listaDireitaRef, onRemove]);

  return (
    <Row>
      <Col sm={5} md={5}>
        {tituloEsquerda}
        <Row>
          <Col>
            <Form.Control
              as="select"
              ref={listaEsquerdaRef}
              multiple={listaEsquerdaMultipla}
              htmlSize={itensVisiveis}
              className="form-control-horizontal-bar"
              disabled={disabled}
              onChange={(e) => {
                setEsquerdaTemSelecao(e.target.selectedOptions.length > 0);
              }}
            >
              {(listaEsquerda || []).map((item) => (
                <option key={item.chave} value={item.chave} title={item.descricao}>
                  {item.descricao}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Row>
      </Col>
      <Col sm={2} md={2} style={{ alignSelf: "center" }}>
        <Button
          variant="primary"
          block
          onClick={() => {
            if (listaEsquerdaRef.current?.selectedOptions.length) {
              onAddHandler();
            } else {
              setEsquerdaTemSelecao(false);
            }
          }}
          disabled={disabled || !esquerdaTemSelecao}
        >
          {textoBotaoAdicionar}
        </Button>
        <Button
          variant="danger"
          block
          onClick={() => {
            if (listaDireitaRef.current?.selectedOptions.length) {
              onRemoveHandler();
            } else {
              setDireitaTemSelecao(false);
            }
          }}
          disabled={disabled || !direitaTemSelecao}
        >
          {textoBotaoRemover}
        </Button>
      </Col>
      <Col as={Col} sm={5} md={5}>
        {tituloDireita}
        <Row>
          <Col>
            <Form.Control
              as="select"
              ref={listaDireitaRef}
              multiple={false}
              htmlSize={itensVisiveis}
              className="form-control-horizontal-bar"
              disabled={disabled}
              onChange={(e) => {
                setDireitaTemSelecao(e.target.selectedOptions.length > 0);
              }}
            >
              {(listaDireita || []).map((item) => (
                <option key={item.chave} value={item.chave} title={item.descricao}>
                  {item.descricao}
                </option>
              ))}
            </Form.Control>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default DoubleListbox;
